import { createCRUDConstants } from "../../../utils/redux.utils";

export const namespace = "ROLES"
export const rolesConstants = createCRUDConstants(namespace, ["UPDATE", "REMOVE","PERMISSION"]);

export const permissions="PERMISSION"
export const permissionsConstant= createCRUDConstants(permissions, ["PERMISSION"]);